import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { INITIAL_STATE } from '../const'
import type { AuthStore } from '../types'

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      setAccessToken: (accessToken) => set({ accessToken }),
      setRefreshToken: (refreshToken) => set({ refreshToken }),
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setUserWithOtp: (userWithOtp) => set({ userWithOtp }),
      setVerifiedOtp: (verifiedOtp) => set({ verifiedOtp }),
      clearUserWithOtp: () => set({ userWithOtp: null, verifiedOtp: null }),
    }),
    { name: 'auth-store', storage: createJSONStorage(() => localStorage) }
  )
)
